import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import installMdi from './plugins/mdi'
import './assets/font.css'
import animated from 'animate.css'
import { ElCollapseTransition } from 'element-plus'
import axios from 'axios'
import VueAxios from 'vue-axios'
import gtag from 'vue-gtag-next'

const app = createApp(App)
installElementPlus(app)
installMdi(app)
app
  .use(store)
  .use(router)
  .use(animated)
  .use(VueAxios, axios)
  .component(ElCollapseTransition.name, ElCollapseTransition)
  .use(gtag, {
    property: {
      id: 'G-LRHET9SHQB'
    }
  }, router)
  .mount('#app')
